import { render, staticRenderFns } from "./RelationshipToProperty.vue?vue&type=template&id=7e70ebba&scoped=true&"
import script from "./RelationshipToProperty.vue?vue&type=script&lang=js&"
export * from "./RelationshipToProperty.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipToProperty.vue?vue&type=style&index=0&id=7e70ebba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70ebba",
  null
  
)

export default component.exports